import { NgModule } from "@angular/core";

import { EnquiryRoutingModule } from "./enquiry-routing.module";
import { SharedModule } from "../shared/shared.module";

import { EmailService } from "./shared/email.service";
import { EnquiryService } from "./shared/enquiry.service";
import { DocumentService } from "./shared/document.service";

import { DownloadQuoteDialogComponent } from "./download-quote-dialog/download-quote-dialog.component";
import { EmailEnquiryDialogComponent } from "./email-enquiry-dialog/email-enquiry-dialog.component";
import { EmailHistoryDialogComponent } from "./email-history-dialog/email-history-dialog.component";
import { EnquiryDetailComponent } from "./enquiry-detail/enquiry-detail.component";
import { EnquiryListComponent } from "./enquiry-list/enquiry-list.component";

@NgModule({
    imports: [
        EnquiryRoutingModule,
        SharedModule,
    ],

    declarations: [
        DownloadQuoteDialogComponent,
        EmailEnquiryDialogComponent,
        EmailHistoryDialogComponent,
        EnquiryDetailComponent,
        EnquiryListComponent,
    ],

    entryComponents: [
        DownloadQuoteDialogComponent,
        EmailEnquiryDialogComponent,
        EmailHistoryDialogComponent,
    ],

    providers: [
        EmailService,
        EnquiryService,
        DocumentService,
    ]
})
export class EnquiryModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/enquiry.module.ts